var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalEscalation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m99.984 399.98v525c0 68.906 56.062 125.02 125.02 125.02h750c68.906 0 125.02-56.062 125.02-125.02v-525zm753.37 521.29c-13.547 23.484-37.828 37.5-64.969 37.5h-376.78c-27.094 0-51.375-14.016-64.969-37.453-13.547-23.484-13.547-51.516 0-75.047l188.39-326.34c13.547-23.438 37.828-37.5 64.969-37.5s51.422 14.016 64.969 37.5l188.39 326.34c13.547 23.484 13.594 51.516 0 75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m631.26 845.63c0 41.672-62.531 41.672-62.531 0s62.531-41.672 62.531 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m600 789.32c-13.781 0-24.984-11.156-24.984-24.984v-150c0-13.828 11.203-24.984 24.984-24.984s24.984 11.156 24.984 24.984v150c0 13.828-11.203 24.984-24.984 24.984z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m975 150h-750c-68.906 0-125.02 56.062-125.02 125.02v75h999.98v-75c0-68.906-56.062-125.02-125.02-125.02zm-750 137.48c-20.719 0-37.5-16.781-37.5-37.5s16.781-37.5 37.5-37.5 37.5 16.781 37.5 37.5-16.781 37.5-37.5 37.5zm112.5 0c-20.719 0-37.5-16.781-37.5-37.5s16.781-37.5 37.5-37.5 37.5 16.781 37.5 37.5-16.781 37.5-37.5 37.5zm112.5 0c-20.719 0-37.5-16.781-37.5-37.5s16.781-37.5 37.5-37.5 37.5 16.781 37.5 37.5-16.781 37.5-37.5 37.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalEscalation);
export default __webpack_public_path__ + "static/media/InternalEscalation.8493827fbacbe8d1c43fc242c47008e4.svg";
export { ForwardRef as ReactComponent };